var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 516 240",
    style: {
      enableBackground: "new 0 0 516 240"
    },
    xmlSpace: "preserve",
    "aria-label": "Zoom Logo",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D8CFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 516,
    height: 240
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.3,91.7c-7.8-7.8-18-11.7-28.3-11.7H196c-10.2,0-20.5,3.9-28.3,11.7c-15.6,15.6-15.6,40.9,0,56.6 c15.6,15.6,40.9,15.6,56.6,0C239.9,132.7,239.9,107.3,224.3,91.7z M213,137c-9.4,9.4-24.6,9.4-33.9,0c-9.4-9.4-9.4-24.6,0-33.9 c9.4-9.4,24.6-9.4,33.9,0C222.3,112.4,222.3,127.6,213,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M308.3,91.7c-7.8-7.8-18-11.7-28.3-11.7c-10.2,0-20.5,3.9-28.3,11.7c-15.6,15.6-15.6,40.9,0,56.6 c15.6,15.6,40.9,15.6,56.6,0C323.9,132.7,323.9,107.3,308.3,91.7z M297,137c-9.4,9.4-24.6,9.4-33.9,0c-9.4-9.4-9.4-24.6,0-33.9 c9.4-9.4,24.6-9.4,33.9,0C306.3,112.4,306.3,127.6,297,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,159.8l4,0.2h60l-0.2-4c-0.5-6.6-5.2-11.4-11.8-11.8l-4-0.2h-36l48-48l-0.2-4c-0.3-6.6-5.2-11.5-11.8-11.8 l-4-0.2l-60,0l0.2,4c0.5,6.5,5.3,11.4,11.8,11.8l4,0.2h36l-48,48l0.2,4C84.6,154.6,89.4,159.4,96,159.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.8,104c1.4,2.4,1.8,5,2,8l0.2,4v28l0.2,4c0.4,6.5,5.2,11.4,11.8,11.8l4,0.2v-44l0.2-4c0.2-3,0.6-5.7,2-8.1 c2.8-4.8,7.9-7.9,13.8-7.9c5.9,0,11.1,3.2,13.9,8c1.4,2.4,1.8,5.1,1.9,8l0.2,4v28l0.2,4c0.4,6.6,5.2,11.4,11.8,11.8l4,0.2v-44v-4 c0-17.7-14.3-32-32-32c-9.6,0-18.1,4.2-24,10.8c-5.9-6.6-14.4-10.8-24-10.8c-6.6,0-12.8,2-17.9,5.5C335,82,328,80,324,80v80l4-0.2 c6.7-0.4,11.5-5.2,11.8-11.8l0.2-4v-28l0.2-4c0.2-3,0.6-5.7,2-8c2.8-4.8,7.9-8,13.8-8C361.9,96,367.1,99.2,369.8,104z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomLogoWhite);
export default __webpack_public_path__ + "static/media/ZoomLogoWhite.3d67cdd657605ce99723ffd95fc8a4fd.svg";
export { ForwardRef as ReactComponent };